import React, { useState, useRef, useEffect } from "react";
import ReactSlick from "react-slick";

const Slider = ReactSlick.default ?? ReactSlick;

export  function ImageSlider({ pictureUrls }) {
    // React Slick settings


    const [isDragging, setIsDragging] = useState(false);
    const [modalOpen, setModalOpen] = useState(false);
    const [selectedImage, setSelectedImage] = useState("");
    const handleBeforeChange = () => setIsDragging(true);
    const handleAfterChange = () => setTimeout(() => setIsDragging(false), 50);
    const modalRef = useRef();

    const handleClick = (image) => {
        if (!isDragging) {
            setSelectedImage(image);
            setModalOpen(true);
            //document.body.style.overflow = 'hidden';
        }
    };

    const closeModal = () => {
        setModalOpen(false);
        document.body.style.overflow = 'unset';
    };


    useEffect(() => {
        if (!modalRef.current) return;
        if (modalOpen) {
            modalRef.current.showModal();
        } else {
            modalRef.current.close();
        }
    }, [modalOpen]);

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
      slidesToScroll: 1,
      beforeChange: handleBeforeChange,
      afterChange: handleAfterChange,
    lazyLoad: 'ondemand', // Lazy load images as the slides change
  };

  // Split the pictureUrls and filter out empty ones
  const images = pictureUrls.split("!!").filter(url => url !== "");

  if(images.length === 1){

    return (
    <div>
            <img src={images[0]} alt={`delebilde`} onClick={() => handleClick(images[0])} className='single-image' loading="lazy" />

            {modalOpen && (
                <dialog ref={modalRef} className="modal-overlay" onClick={() => setModalOpen(false)}>
                    <div className="modal-content">
                        <img src={selectedImage} alt="Full Size" className="modal-image" />
                    </div>
                </dialog>
            )}
      </div>
    )
  }

  return (
    <div className="slider-container">
      {images.length > 0 ? (
        <Slider {...settings}>
          {images.map((imageUrl, index) => (
            <div key={index}>
                  <img src={imageUrl} onClick={() => handleClick(imageUrl)} alt={`Slide ${index}`} className='slide-image' loading="lazy" />
            </div>
          ))}
        </Slider>
      ) : (
        <p>No images available</p>
          )}

          {modalOpen && (
              <dialog ref={modalRef} className="modal-overlay" onClick={() => setModalOpen(false)}>

                  {/*<Slider {...settings}>*/}
                  {/*    {images.map((imageUrl, index) => (*/}
                  {/*        <div key={index}>*/}
                  {/*            <img src={imageUrl}  alt={`Slide ${index}`} className='slide-image' loading="lazy" />*/}
                  {/*        </div>*/}
                  {/*    ))}*/}
                  {/*</Slider>*/}

                  <div className="modal-content-img">
                      <img src={selectedImage} alt="Full Size" className="modal-image" />
                  </div>
              </dialog>
          )}
    </div>
  );
}